import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { Grid, Button, useTheme, Box, Link, Typography } from '@material-ui/core'

import useViewportSize from '~/components/useViewportSize'
import { useLiterals } from '~/components/Literals'

import ls from '~/localStorage'
import { TYPES } from '~/actions'
import { viewSelector } from '~/selectors'

const useStyles = makeStyles((theme) => ({
  root: ({ isMobile }) => ({
    width: isMobile ? 'calc(100% - 40px)' : 'calc(100% - 448px)',
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 20,
    right: 20
  }),
  container: ({ isMobile }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: isMobile ? '16px 20px' : '8px 8px 8px 20px',
    borderRadius: 4,
    width: isMobile ? '100%' : 'auto',
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[4],
    '& > p': {
      width: '80%',
      color: theme.palette.primary.contrastText
    },
    zIndex: '9999',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  }),
  itemContainer: ({ isMobile }) => ({
    display: 'flex',
    flexDirection: isMobile ? 'row-reverse' : 'row',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }),
  action: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: 16,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20
    }
  },
  button: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    cursor: 'pointer'
  }
}))

export default function Cookie() {
  const urlDomain = window.location.toString()
  const [open, setOpen] = useState(true)
  const { getLiteral } = useLiterals()
  const viewport = useViewportSize()
  const theme = useTheme()
  const isMobile = theme.gofind.desktopMaxWidth > viewport.width
  const classes = useStyles({ isMobile })
  const view = useSelector(viewSelector)
  const history = useHistory()

  const handleGranted = () => {
    setOpen(!open)

    const permission = {
      analytics_storage: 'granted'
    }

    ls.setItem('gofind-user-allow-cookies', permission)

    window?.gtag('consent', 'update', permission)
  }

  const handleDenied = () => {
    setOpen(!open)
    const permission = {
      analytics_storage: 'denied'
    }

    ls.setItem('gofind-user-allow-cookies', permission)

    window?.gtag('consent', 'update', permission)
  }

  let cookieMessage = getLiteral('1991')
  const lastSpace = cookieMessage.lastIndexOf(' ')
  cookieMessage = [
    cookieMessage.slice(0, lastSpace),
    '\u00A0',
    cookieMessage.slice(lastSpace + 1)
  ].join('')

  const seeTerms = useCallback(() => {
    history?.replace('/termos')
  }, [history])

  return (
    open &&
    !urlDomain.includes('/onlineStore') &&
    view !== TYPES.VIEW_TERM && (
      <Box className={classes.root} component="div">
        <Grid container className={classes.container}>
          <Grid item xs={isMobile ? 12 : 6} md={8} style={{ marginBottom: isMobile ? 8 : 0 }}>
            <Typography style={{ fontSize: 14 }}>
              <span>{cookieMessage} </span>
              <Link
                style={{
                  display: 'inline-block',
                  marginRight: isMobile ? 0 : 16,
                  textAlign: 'center',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                color="textPrimary"
                target="_blank"
                rel="noreferrer"
                onClick={seeTerms}
              >
                {getLiteral('2018')}
              </Link>
            </Typography>
          </Grid>

          <Grid
            item
            xs={isMobile ? 12 : 6}
            lg={4}
            style={{ width: '100%' }}
            className={classes.itemContainer}
          >
            <Button
              className={classes.button}
              variant="text"
              style={{
                marginRight: isMobile ? 0 : 16,
                textAlign: 'center',
                textDecoration: 'underline'
              }}
              onClick={handleDenied}
              fullWidth={isMobile}
            >
              {getLiteral('2816')}
            </Button>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              style={{ marginRight: isMobile ? 16 : 0 }}
              onClick={handleGranted}
              fullWidth={isMobile}
            >
              {getLiteral('2019')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    )
  )
}
